var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.vehicle
    ? _c(
        "div",
        [
          _vm.vehicle.nichibo_message_id
            ? _c(
                "div",
                { staticClass: "staff-only-messages" },
                [
                  _vm.vehicle.message_images
                    ? _c(
                        "div",
                        { staticClass: "nichibo-images" },
                        [
                          _c("h4", [_vm._v("Bidder images")]),
                          _vm._v(" "),
                          _vm._l(_vm.vehicle.message_images, function(photo) {
                            return [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: photo,
                                    "data-fancybox": "message_photo"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "message_photo",
                                    attrs: {
                                      src: photo,
                                      alt: "Click to view a larger photo",
                                      height: "25"
                                    }
                                  })
                                ]
                              )
                            ]
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$userIsAdmin()
                    ? [
                        _vm._l(_vm.vehicle.messages, function(msg) {
                          return [
                            msg.message
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "bid history-bid",
                                    class: _vm.vehicleMessageClass(msg),
                                    on: {
                                      click: function($event) {
                                        return _vm.selectMessage(msg)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "date item" }, [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(_vm.getDate(msg.created_at)) +
                                          "\n                    "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "hour item" }, [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(_vm.getTime(msg.created_at)) +
                                          "\n                    "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "message-by item" },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(msg.name) +
                                            " \n                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "note item" }, [
                                      _c("span", [
                                        _c("strong", [_vm._v(" staff: ")]),
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(msg.message) +
                                            "\n                    "
                                        )
                                      ])
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "history-buttons" }, [
                          _c(
                            "a",
                            {
                              staticClass: "link staff-message",
                              on: { click: _vm.openStaffMessageModal }
                            },
                            [
                              _vm._v(
                                "\n                    Nichibo Message\n                "
                              )
                            ]
                          )
                        ])
                      ]
                    : _vm._e()
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("staff-message", {
            ref: "staffMessage",
            on: { changed: _vm.onStaffMessageChanged }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38d14e7f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38d14e7f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Common/VehicleMessages.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-38d14e7f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Common/VehicleMessages.vue
// module chunks = 0